/**
 * Gruppkraft — enkel cookie-/samtyckeshantering.
 * Ingen statistik- eller marknadsföringsspårning laddas förrän besökaren
 * aktivt har godkänt det här. "Endast nödvändiga" laddar inga tredjepartsverktyg.
 * Val sparas i localStorage och gäller i 180 dagar.
 */
(function () {
  "use strict";

  var STORAGE_KEY = "gk_consent";
  var MAX_AGE_DAYS = 180;

  function readConsent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      var ageDays = (Date.now() - data.ts) / (1000 * 60 * 60 * 24);
      if (ageDays > MAX_AGE_DAYS) return null;
      return data;
    } catch (err) {
      return null;
    }
  }

  function writeConsent(analytics) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ analytics: analytics, ts: Date.now() })
      );
    } catch (err) {
      /* localStorage kan vara otillgängligt (privat läge) — banner visas igen nästa besök */
    }
  }

  function loadAnalytics(root) {
    var gtmId = root.getAttribute("data-gtm-id");
    var ga4Id = root.getAttribute("data-ga4-id");

    if (gtmId) {
      var gtmScript = document.createElement("script");
      gtmScript.async = true;
      gtmScript.src = "https://www.googletagmanager.com/gtm.js?id=" + gtmId;
      document.head.appendChild(gtmScript);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
    } else if (ga4Id) {
      var gaScript = document.createElement("script");
      gaScript.async = true;
      gaScript.src = "https://www.googletagmanager.com/gtag/js?id=" + ga4Id;
      document.head.appendChild(gaScript);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", ga4Id, { anonymize_ip: true });
    }

    window.gkTrackEvent && window.gkTrackEvent("consent_analytics_enabled", {});
  }

  document.addEventListener("DOMContentLoaded", function () {
    var banner = document.querySelector("[data-cookie-consent]");
    if (!banner) return;

    var existing = readConsent();
    if (existing) {
      banner.setAttribute("data-visible", "false");
      if (existing.analytics) loadAnalytics(banner);
      return;
    }

    banner.setAttribute("data-visible", "true");

    var acceptBtn = banner.querySelector("[data-consent-accept]");
    var necessaryBtn = banner.querySelector("[data-consent-necessary]");

    if (acceptBtn) {
      acceptBtn.addEventListener("click", function () {
        writeConsent(true);
        banner.setAttribute("data-visible", "false");
        loadAnalytics(banner);
      });
    }

    if (necessaryBtn) {
      necessaryBtn.addEventListener("click", function () {
        writeConsent(false);
        banner.setAttribute("data-visible", "false");
      });
    }
  });
})();
